import request from '@/utils/request'

// 获取下载任务列表
export function apiGetList (query) {
  return request({
    url: '/dc/dcTask/getList',
    method: 'get',
    params: query
  })
}
